import React from 'react';
import type { TimeCardShift } from '../../../../../js/api';
import { Dialog, DialogBody, DialogTitle } from '../../../components/dialog';
import { DocumentsTab } from '../../../components/documents-tab';

const CONTEXT_TYPE = 'assignments.timecardshift';

export const ShiftDocumentsModal: React.FC<{
  open: boolean;
  onClose: () => void;
  shift?: TimeCardShift;
  ownerId?: string;
  relatedProviderId?: string;
}> = ({ open, onClose, shift, ownerId, relatedProviderId }) => {
  if (!shift) return null;

  return (
    <Dialog open={open} onClose={onClose} size="lg">
      <DialogTitle>
        <>
          Shift Documents
          <div className="tw:text-xs tw:text-zinc-500 tw:font-normal">
            {shift.start_on} {shift.start_time?.slice(0, 5)} – {shift.end_time?.slice(0, 5)}
          </div>
        </>
      </DialogTitle>
      <DialogBody>
        <DocumentsTab
          contextType={CONTEXT_TYPE}
          contextId={shift.id}
          ownerId={ownerId || ''}
          relatedProviderId={relatedProviderId}
        />
      </DialogBody>
    </Dialog>
  );
};
